import { render, staticRenderFns } from "./TableUnity.vue?vue&type=template&id=16a0c0a6&scoped=true&"
import script from "./TableUnity.vue?vue&type=script&lang=js&"
export * from "./TableUnity.vue?vue&type=script&lang=js&"
import style0 from "./TableUnity.vue?vue&type=style&index=0&id=16a0c0a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a0c0a6",
  null
  
)

export default component.exports